import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';
import { Link } from 'react-router-dom';

const StyledBlock = styled.td`
    height: 48px;
    padding: 0;
    text-align: ${ (props) => {
        return props.align;
    } };

    &:first-child {
        padding: 0 0 0 12px;
    }
`;

const StyledLink = styled.div`
    a {
        display: flex;
        height: 48px;
        width: 100%;
        align-items: center;
        justify-content: ${ (props) => {
            return props.align;
        } };
        text-decoration: none;
        color: ${ theme.table.body.row.color };

        &:hover {
            text-decoration: none;
            color: ${ theme.table.body.row.color };
            cursor: pointer;
        }
    }
`;

const StyledNoLink = styled.span`
    display: flex;
    height: 48px;
    width: 100%;
    align-items: center;
    justify-content: ${ (props) => {
        return props.align;
    } };
`;

const TableBodyCell = (props) => {
    const {
        align,
        field,
        link,
        record,
        resource,
        source,
    } = props;

    const childElement = React.cloneElement(field, {
        record: record,
        resource: resource,
    });

    return (
        <StyledBlock
            key={ `${ record.id }-${ source }` }
        >
            {
                link ?
                    <StyledLink align={ align }>
                        <Link to={ `/${ resource }/${ record.id }/${ link }` }>
                            { childElement }
                        </Link>
                    </StyledLink>
                    :
                    <StyledNoLink align={ align }>
                        { childElement }
                    </StyledNoLink>
            }
        </StyledBlock>
    );
};

TableBodyCell.propTypes = {
    align: PropTypes.string,
    field: PropTypes.element,
    link: PropTypes.string,
    record: PropTypes.object.isRequired,
    resource: PropTypes.string,
    source: PropTypes.string,
};

export default TableBodyCell;



// WEBPACK FOOTER //
// ./src/components/table/TableBodyCell.js